import type { IconData } from '@stacksjs/iconify-core'

export const fileCheckAlternate: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M29.14 42.987c5.119-.063 8.743-.344 11.108-.614c2.2-.252 3.85-1.903 4.092-4.105c.319-2.89.66-7.741.66-15.268c0-2.876-.05-5.361-.13-7.496c-.351-.982-1.55-3.568-5.266-7.21c-3.941-3.864-6.67-4.952-7.519-5.217A162 162 0 0 0 27 3c-6.264 0-10.566.32-13.248.627c-2.201.252-3.85 1.903-4.092 4.105c-.225 2.034-.46 5.04-.58 9.268\"/><path d=\"M44.884 15.96c-2.087.31-5.84.072-8.688-.192a4.664 4.664 0 0 1-4.228-4.21c-.269-2.803-.507-6.468-.181-8.489M3 33a12 12 0 1 0 24 0a12 12 0 1 0-24 0\"/><path d=\"m20 29l-5.882 8L10 32.333\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default fileCheckAlternate
